module.exports = __webpack_public_path__ + "img/desktop-instructions.dde92769.png";